import React, {useState} from 'react';
import {Link,NavLink} from 'react-router-dom';
import {FiChevronDown,FiAlignRight,FiXCircle } from "react-icons/fi";
import './sapNavBar.css';
import { useMsal } from "@azure/msal-react";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

const SapNavBar = () => {
    const [isMenu, setisMenu] = useState(false);
    const [isResponsiveclose, setResponsiveclose] = useState(false);
    const [open, setOpen] = useState(false); 
    
    const handleOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };
    const toggleClass = () => {
      setisMenu(isMenu === false ? true : false);
      setResponsiveclose(isResponsiveclose === false ? true : false);
    };
    let boxClass = ["main-menu"];
    if(isMenu) {
        boxClass.push('menuq2');
    }else{
        boxClass.push('');
    }
    const showSubMenu =()=>{
      document.getElementById("myDropdown").classList.toggle("show");
      // document.getElementById("sp-menu-item").classList.toggle("is-active");
      // document.getElementById("nav-links").classList.toggle("nav-links");
    }
    window.onclick = function(event) {
      if (!event.target.matches('.sp-nav-links')) {
        var dropdowns = document.getElementsByClassName("sap-sp-body");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    
    let ipsLoggedInEnterpriseId = '';
    let ipsLoggedInJobFamilyDescription = "";
    if(activeAccount) {
      ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID; 
      ipsLoggedInJobFamilyDescription = activeAccount.idTokenClaims.jobFamilyDescription;
    }        
    
    const allowedUsersForSAPFeedbacksData = [      
      'vanitadevi.patil',
      's.saraswathi',
      'poruri.rama.pavani',      
      'h.srinivasan',
      'jeevadharani.ramanan',
      'ankur.e.mishra',
      'uma.rani.battu'  
    ];

    const allowedUsersForSAPStatistics = [      
      'vanitadevi.patil',
      's.saraswathi',
      'poruri.rama.pavani',      
      'h.srinivasan',
      'jeevadharani.ramanan',
      'ankur.e.mishra',
      'uma.rani.battu'     
    ];

    return (
      <div className="header__middle">
        <div className="head-container">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
                <li className="menu-item">
                  <NavLink
                    onClick={toggleClass}
                    activeClassName="is-active"
                    className="nav-links"
                    to="/SAPAcademy/Courses"
                  >
                    Courses
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    onClick={toggleClass}
                    activeClassName="is-active"
                    className="nav-links"
                    to="/SAPAcademy/LearningPaths"
                  >
                    
                    Learning Paths
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    onClick={()=>{showSubMenu(); toggleClass()}}
                    activeClassName="is-active"
                    className="sp-nav-links"
                    id ="sp-menu-item"
                    to="/SAPAcademy/specialPrograms"
                  >
                    Special Programs
                  </NavLink>
                  <ul>
                    <li className="sub-menu-item" >
                      <div className="sap-sp-body" id="myDropdown">
                        <div className="sap-sp-body-row">
                          <div className="sap-sp-body-text">
                            <a
                              href="https://atci.lkm.ind.accenture.com/iSpark/SAP-BTP"
                              target="_blank"
                            >
                              iSpark Program
                            </a>
                          </div>
                        </div>
                        <div className="sap-sp-body-row">
                          <div className="sap-sp-body-text">
                            <a
                              href="https://deepknowledge.accenture.com/home/sap-leader-series"
                              target="_blank"
                            >
                              SAPQ for Leaders
                            </a>
                          </div>
                        </div>
                        <div className="sap-sp-body-row">
                          <div className="sap-sp-body-text">
                            <a
                              href="https://atci.lkm.accenture.com/QuantumImpact/home"
                              target="_blank"
                            >
                              Quantum Impact Program
                            </a>
                          </div>
                        </div>
                        <div className="sap-sp-body-row">
                          <div className="sap-sp-body-text">
                            <a onClick={handleOpen}>SAP Ascend</a>
                            <Modal
                              hideBackdrop
                              open={open}
                              onClose={handleClose}
                              aria-labelledby="child-modal-title"
                              closeAfterTransition
                              aria-describedby="child-modal-description"
                            >
                              <Box className="ascend_box">
                                <div>
                                  <div className="ascend_heading">
                                    <h3 className="paramodel">SAP Ascend </h3>
                                    <span
                                      className="close_btn_model"
                                      onClick={handleClose}
                                    >
                                      Close
                                    </span>
                                  </div>
                                  <hr />
                                  <div>
                      <div>
                        <p className="SAP_AscendInfo">
                          SAP is a major business group in Enterprise and Industry Technologies (E&IT) that helps our clients unlock
                          incremental business value and enable the highest
                          growth value for Accenture by combining technology and
                          industry excellence to create innovative solutions.
                          Our SAP practice is in high demand across many
                          industries.
                          </p>
                          <br />
                          <p>
                          To help us increase and strengthen our SAP presence
                          and provide our SAP practitioners with a market edge,
                          we had launched <strong>SAP Ascend</strong>, an SAP
                          Certification drive.
                          </p>
                        
                        <br />
                        <p>
                          For our SAP practitioners, this is a great chance to
                          increase their proficiency in various SAP areas. The
                          certifications in the drive cover the following areas:
                        </p>
                        <br />
                      </div>
                      <div className="acend_points">
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Customer Experience (CX)</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Data</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Finance</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Information Lifecycle Management (ILM)</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Logistics & Supply Chain</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Open Text</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Basis/HANA/J2C</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>
                            Governance, Risk, and Compliance (GRC) & Security
                          </span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>SAP Solution Manager</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>SuccessFactors</span>
                        </div>
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/SAP/Arrow.svg"
                            }
                            alt="Arrow"
                          />
                          <span>Tech Dev</span>
                        </div>
                      </div>
                      <div className="contact-us">
                      <p>
                      Write to us @ <a href="mailto:ATCI.SAP.ASCEND@accenture.com">ATCI.SAP.ASCEND@accenture.com</a> for any queries on this program.
                        </p>
                      </div>
                    </div>
                                </div>
                              </Box>
                            </Modal>
                          </div>
                        </div>
                        <div className="sap-sp-body-row">
                          <div className="sap-sp-body-text">
                            <a
                              href="https://deepknowledge.accenture.com/home/prog-sac"
                              target="_blank"
                            >
                              SAP Analytics Cloud (SAC) for Leaders
                            </a>
                          </div>
                        </div>
                        <div className="sap-sp-body-row">
                          <div className="sap-sp-body-text">
                            <a
                              href="https://deepknowledge.accenture.com/home/prog-sap-fse"
                              target="_blank"
                            >
                              SAP Full Stack Program
                            </a>
                          </div>
                        </div>
                        <div className="sap-sp-body-row">
                          <div className="sap-sp-body-text">
                            <a
                              href="https://deepknowledge.accenture.com/home/sap-analytics"
                              target="_blank"
                            >
                              SAP Analytics ++ Ecosphere
                            </a>
                          </div>
                        </div>
                        <div className="sap-sp-body-row">
                          <div className="sap-sp-body-text">
                            <a
                              href="https://deepknowledge.accenture.com/home/prog-sap-btp"
                              target="_blank"
                            >
                              SAP Business Technology Platform (BTP) Role-Based Learning Journey
                            </a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li className="menu-item">
                  <NavLink
                    onClick={toggleClass}
                    activeClassName="is-active"
                    className="nav-links"
                    to="/SAPAcademy/Testimonials"
                  >
                    
                    Testimonials
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    onClick={toggleClass}
                    activeClassName="is-active"
                    className="nav-links"
                    to="/SAPAcademy/Experts"
                  >
                    
                    LKM Experts
                  </NavLink>
                </li>
                {/* {ipsLoggedInJobFamilyDescription === "Accenture Leadership" || allowedUsersForSAPStatistics.includes(ipsLoggedInEnterpriseId) ?  
                  <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/SAPAcademy/KeyStatistics"> Key Statistics </NavLink>   
                  </li> : ''} */}
                <li className="menu-item">
                  <a
                    onClick={toggleClass}
                    activeClassName="is-active"
                    className="nav-links"
                    target="_blank"
                    href="https://atci.lkm.eitacademy.accenture.com/SAPAcademy/sap-calendar/"
                    rel="noreferrer"
                  >
                    
                    SAP Calendar
                  </a>
                </li>

                <li className="menu-item">
                  <NavLink
                    onClick={toggleClass}
                    activeClassName="is-active"
                    className="nav-links"
                    to="/SAPAcademy/Awards"
                  >
                    
                    Awards
                  </NavLink>
                </li>

                <li className="menu-item">
                  <NavLink
                    onClick={toggleClass}
                    activeClassName="is-active"
                    className="nav-links"
                    to="/SAPAcademy/Feedback"
                  >
                    
                    Feedback
                  </NavLink>
                </li>
                {allowedUsersForSAPFeedbacksData.includes(
                  ipsLoggedInEnterpriseId
                ) ? (
                  <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/SAPAcademy/Feedbacks"
                    >
                      
                      Admin
                    </NavLink>
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    );
}

export default SapNavBar;